import React from 'react'

import FormError from "../../../../../../../core/gd-form/common/form-error/form-error"
import FormManager from "../../../../../../../core/gd-form/common/form-manager"
import MultiselectOptions from "../../../../../../../core/gd-ui/side-filters/multiselect-options/multiselect-options"
import CustomView_rowComponent from "./row-component"

type Props = {
    label           : string

    form            : FormManager
    formFieldName   : string

    options         : Option[]

    disabled?       : boolean
}

export default function SelectOptionMulti(props: Props) {

    const onMultiselectSelect = (options: any) => {
        props.form.onFormComponentValueChange(props.formFieldName, options)
    }

    const filterTypes = props.form.getValue(props.formFieldName)

    return (
        <CustomView_rowComponent label={props.label}>
            <MultiselectOptions type                = "form"
                                title               = ""
                                filterTypes         = {filterTypes}
                                typeFilterValues    = {props.options}
                                isFoldable          = {false}
                                onSelect            = {onMultiselectSelect}/>
            <FormError form = {props.form}
                       name = {props.formFieldName}/>
        </CustomView_rowComponent>
    )
}